import PropTypes from "prop-types";
import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import settings from "../../configs/appSettings";
import {setTopRailNavigation} from "../../actions/nav/topRailNavAction";
import {CurrentUser} from "../../services/CurrentUser";
import { HttpService } from "../../services/api/HttpService";
import permissionService from "../../services/PermissionService";
import {UserMenuModel} from "../../models/platformUserModel";
import {transferToProduct} from "../../actions/nav/productTransferAction";
import _ from "lodash";

class UserNav extends Component {

    static propTypes = {
        isActive: PropTypes.bool,
        setSelectedTopRailNav: PropTypes.func,
        transferToNorthSettingsPage: PropTypes.func,
        user: PropTypes.shape(UserMenuModel)
    };

    static defaultProps = {
        isActive: undefined
    };

    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        window.addEventListener("click", this.closeUserMenuIfOpen);
    }

    componentWillUnmount() {
        window.removeEventListener("click", null);
    }

    closeUserMenuIfOpen = (e) => {
        if (this.props.isActive) {
            const userClickedOutsideOfMenu = !(_.find(e.path, (p) => {
                return p.className && p.className.includes('user-menu');
            }));
            if (userClickedOutsideOfMenu) {
                this.toggleUserMenu(e);
            }
        }
    };

    toggleUserMenu = (e) => {
        e.stopPropagation();
        if (_.isUndefined(this.props.user)) { return; }
        this.props.setSelectedTopRailNav(this.props.isActive ? '' : 'User');
    };

    handleSettingsLinkClick = () => {
        HttpService
            .createForTransfer()
            .requestTransfer("Customer Administration", "")
            .then(result => {
                const nsettingsUrl = `${result.data.redirectUrl}?ReturnUrl=${encodeURIComponent(window.location.pathname)}`;
                window.location.assign(nsettingsUrl);
            })
            // eslint-disable-next-line no-console
            .catch(error => console.error(error));
    };

    logoutAndNavigateToLoginPage = () => {
        CurrentUser.logout();
        window.location.replace(`${settings.authUiUrl}?referrer=${settings.clientId}&ReturnUrl=${encodeURIComponent(window.location.pathname)}`);
    };

    render() {
        const {isActive, user} = this.props;

        const settingsLink = isActive && !_.isUndefined(user) && permissionService.showSettings()
            ? <li><a onClick={this.handleSettingsLinkClick}>Settings</a></li>
            : undefined;

        const userMenu = isActive
            ? <div className="top-nav-menu user-menu">
                <div className="arrow"/>
                <div className="menu-content">
                    <div className="user-name">{user ? user.fullName : ''}</div>
                    <div className="customer-name">{user ? user.customerName : ''}</div>
                    <div>
                        <ul>
                            {settingsLink}
                            <li>
                                <a onClick={this.logoutAndNavigateToLoginPage}>Logout</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            : undefined;

        const activeNavBackground = isActive
            ? <div className="active-nav-icon-background"/>
            : undefined;

        return (
            <div>
                <div className="top-rail-icon-container user-nav-container tooltip is-tooltip-bottom"
                     data-tooltip="User & Settings" onClick={this.toggleUserMenu}>
                    <div className="nav-img-container">
                        <div className="circle">
                            <div className="initials has-text-centered">
                                {user ? user.initials : ''}
                            </div>
                        </div>
                    </div>
                    <div className="hovered-nav-icon-background"/>
                    {activeNavBackground}
                </div>
                {userMenu}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.platformUser.user,
        isActive: state.topRailNav.activeElementId === 'User'
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setSelectedTopRailNav: (selectedElementId) => dispatch(setTopRailNavigation(selectedElementId)),
        transferToNorthSettingsPage: (northProductName) => dispatch(transferToProduct(northProductName, "/main.aspx#/settings/customize"))
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(UserNav));
